// Pages
import RouterView from '@/components/pages/RouterView/Router'

import General from '@/components/pages/Settings/General.vue'
import MyHospitals from '@/components/pages/Settings/MyHospitals.vue'
import AssociateNurse from '@/components/pages/Settings/AssociateNurse.vue'
import AssociateHospital from '@/components/pages/Settings/AssociateHospital_v2.vue'
import ManageLanguages from '@/components/pages/Settings/ManageLanguages.vue'
import ResetPassword from '@/components/pages/Settings/ResetPassword.vue'
import DeleteAccount from '@/components/pages/Settings/DeleteAccount.vue'
import ManageIols from '@/components/pages/Settings/ManageIols.vue'
import ManageNotifications from '@/components/pages/Settings/ManageNotifications.vue'
import EnterRegistrationKey from '@/components/pages/Settings/EnterRegistrationKey.vue'
import ManageRegistrationKeys from '@/components/pages/Settings/ManageRegistrationKeys.vue'
import GenerateAccessCode from '@/components/pages/Settings/GenerateAccessCode.vue'
import AdminOperationUpload from '@/components/pages/Settings/AdminOperationUpload'
import QuestionnairePreferences from '@/components/pages/Settings/QuestionnairePreferences.vue'
import PhinExport from '@/components/pages/Settings/PhinExport.vue'

export default {
  path: '/settings',
  component: RouterView,
  meta: {requiresAuth: true},
  children: [
    {
      path: 'personal-info',
      name: 'PersonalInfo',
      component: General
    },
    {
      path: 'surgeon_hospitals',
      component: MyHospitals,
      name: 'my-hospitals'
    },
    {
      path: 'associate_nurse',
      component: AssociateNurse,
      name: 'AssociateNurse'
    },
    {
      path: 'associate_hospital',
      component: AssociateHospital,
      name: 'AssociateHospital'
    },
    {
      path: 'manage-languages',
      name: 'ManageLanguages',
      component: ManageLanguages
    },
    {
      path: 'reset-password',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: 'delete-account',
      name: 'DeleteAccount',
      component: DeleteAccount
    },
    {
      path: 'manage_iols',
      name: 'ManageIols',
      component: ManageIols
    },
    {
      path: 'manage_notifications',
      name: 'ManageNotifications',
      component: ManageNotifications
    },
    {
      path: 'enter_registration_key',
      name: 'EnterRegistrationKey',
      component: EnterRegistrationKey
    },
    {
      path: 'manage_registration_keys',
      name: 'ManageRegistrationKeys',
      component: ManageRegistrationKeys
    },
    {
      path: 'generate_access_code',
      name: 'GenerateAccessCode',
      component: GenerateAccessCode
    },
    {
      path: 'admin_operation_upload',
      name: 'AdminOperationUpload',
      component: AdminOperationUpload
    },
    {
      path: 'questionnaire_preferences',
      name: 'QuestionnairePreferences',
      component: QuestionnairePreferences
    },
    {
      path: 'phin_export',
      name: 'PhinExport',
      component: PhinExport
    },
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/settings.js